// AWIN deep links: a tracking link that sends the visitor to any page of an
// advertiser's site (its search, a city, a filter) and credits the publisher.
// AWIN's documented format (Link Builder makes the same):
//   https://www.awin1.com/cread.php?awinmid=<advertiser>&awinaffid=<publisher>&clickref=<ref>&ued=<url>
// `clickref` shows in AWIN's Click References report — pass the page the link
// is on, so a sale can be traced back to it. The publisher id is per site
// (one AWIN promotional space each: riviera-todo 3031481, dubai-todo 3134085,
// miami-todo 3142764). Plain links only — no AWIN or advertiser script on
// the page; a click goes through openExternal like every affiliate CTA.

export type AwinProgram = {
  /** The advertiser's programme id (`awinmid`), e.g. 92667 for Sailo. */
  advertiserId: number;
  /** The site's publisher id (`awinaffid`). */
  publisherId: number;
};

/** A tracked link to `url` on the advertiser's site. */
export function awinDeepLink(program: AwinProgram, url: string, clickref?: string): string {
  const params = new URLSearchParams({
    awinmid: String(program.advertiserId),
    awinaffid: String(program.publisherId),
  });
  if (clickref) params.set('clickref', clickref);
  params.set('ued', url);
  return `https://www.awin1.com/cread.php?${params.toString()}`;
}
